"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityCounterType = void 0;
var EntityCounterType;
(function (EntityCounterType) {
    EntityCounterType["ORDER"] = "ORDER";
    EntityCounterType["PAYMENT"] = "PAYMENT";
})(EntityCounterType = exports.EntityCounterType || (exports.EntityCounterType = {}));
